<template>
  <div class="wrapper" ref="wrapper">
    <Group
      v-for="(group, index) in groupedResults"
      :key="group.affinity"
      :group="group"
      :index="groupedResults.length - index"
      @onSizeUpdate="addSize"
      @onClickParty="hideTooltip()"
    />

    <div class="you">
      <Tooltip :show="showTooltip" @click.native="hideTooltip()">
        {{ tooltipLabel }}
      </Tooltip>

      <div class="label">{{ you }}</div>
      <Circles :sizes="groupSizes" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Group from "@/components/Results/Radar/Group";
import Circles from "@/components/Results/Radar/Circles";
import Tooltip from "@/components/UI/Tooltip";

import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default {
  name: "RadarView",

  components: {
    Group,
    Circles,
    Tooltip,
  },

  props: {
    animation: Boolean,
  },

  data: () => ({
    groupSizes: [],
    tl: Object,
    showTooltip: false,
  }),

  computed: {
    ...mapState({
        you: (state) => state.dictionary.general.radar.you,
        tooltipLabel: (state) => state.dictionary.general.radar.tooltip,
        results: (state) => state.results,
    }),

    groupedResults() {
      // group the results by affinity
      // remove empty items from array, added due to the reduce function
      const grouped = this.results
        .reduce((r, a) => {
          r[a.affinity.length] = r[a.affinity.length] || [];
          r[a.affinity.length].push(a);
          return r;
        }, [])
        .filter((el) => el);

      return grouped;
    },
  },

  mounted() {
    // make sure function is executed when DOM is ready
    this.$nextTick(() => this.ready());
  },

  methods: {
    hideTooltip() {
      this.showTooltip = false;
    },

    ready() {
      this.createAnimation();

      if (this.animation) {
        this.tl.play();
        this.$parent.skipRadarAnimation();
      } else {
        this.tl.seek("-=0");
      }
    },

    // receive the height of each group from the child
    // multiply by two for to get the diameter (correct size)
    // and pass the array to the circles component
    addSize(size) {
      this.groupSizes.push(size * 2);
    },

    createAnimation() {
      this.tl = gsap.timeline({
        paused: true,
        delay: 1,
        onComplete: this.onAnimationComplete,
        callbackScope: this,
      });

      this.tl.timeScale(1.2);
      const groups = gsap.utils.toArray(".group");
      const circles = gsap.utils.toArray(".circle");

      circles.forEach((circle, i) => {
        const anim = gsap.timeline();
        const parties = gsap.utils.toArray(groups[i].querySelectorAll(".party"));

        gsap.set(circle, { scale: 0, opacity: 0 });
        gsap.set(parties, { y: 30, opacity: 0 });

        anim.to(circle, { scale: 1, opacity: 1, duration: 1.5, ease: "power4.out", force3D: true });
        anim.to(parties, { y: 0, opacity: 1, duration: 0.8, force3D: true }, 1);
        anim.set(circle, { clearProps: "opacity,transform" });

        this.tl.add(anim, i * 0.7);
      });

      // scroll window down
      this.tl.fromTo(
        window,
        { scrollTo: 0 },
        {
          duration: this.tl.duration() * 1.5,
          scrollTo: { y: "max", autoKill: true },
        },
        0.1
      );
    },

    onAnimationComplete() {
      this.showTooltip = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
  padding-top: 50px;
}

.you {
  background: red;
  width: 130px;
  height: 130px;
  font-size: 30px;
  background: $pink;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  margin: 0 auto 100px;
  position: relative;
  z-index: 1;
}

.label {
  position: relative;
  z-index: 1;
}

.group {
  position: relative;
  z-index: 2;
}
</style>
